import { createContext } from 'react';
import { IS_DARK_MODE_LOCAL_STOREAGE_KEY, LightMode } from '../../constants';
import { Color } from './ThemeConstants';
import { getColorName } from './utils';

export type ThemeContextType = {
  colorName: string;
  color: Color;

  isDarkMode: boolean;
  toggleDarkMode?: () => void;

  colorOverride?: Color;

  // engageRainbow?: (themeId: number) => void;
  // disengageRainbow?: () => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  isDarkMode: localStorage.getItem(IS_DARK_MODE_LOCAL_STOREAGE_KEY) === LightMode.dark,
  color: Color.blue,
  colorName: getColorName(Color.blue),
});
